<template>
  <div class="user-manage">
    <div class="top-navbar">
      <van-icon name="arrow-left" @click="toBack" />
      <span class="text">用户管理</span>
      <span style="font-size: 12px" @click="toAdd">添加用户</span>
      <!-- <van-icon name="setting"  /> -->
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="col">
          <span class="title">用户姓名：</span>
          <span class="cent">{{ item.name }}</span>
        </div>
        <div class="col">
          <span class="title">联系电话：</span>
          <span class="cent">{{ item.mobile }}</span>
        </div>
        <div class="col">
          <span class="title">联系地址：</span>
          <span class="cent">{{ item.address }}</span>
        </div>
        <div class="col">
          <span class="title">购机时间：</span>
          <span class="cent">{{ item.buy_time }}</span>
        </div>
        <div class="col">
          <span class="title">产品型号：</span>
          <span class="cent">{{ item.product_model }}</span>
        </div>
        <div class="btns">
          <van-button class="btn" size="small" @click="toEdit(item.id)"
            >修改</van-button
          >
          <van-button
            class="btn"
            type="danger"
            size="small"
            @click="onDelete(item.id)"
            >删除</van-button
          >
        </div>
      </div>

      <div class="empty" v-if="list.length == 0">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import { indexOp, uploadImg, updateOp, addOp } from "../../api";
export default {
  props: {},
  inject: ["reload"],
  data() {
    return {
      list: "",
    };
  },
  computed: {},
  created() {
    this.getList();
  },
  mounted() {},
  watch: {},
  methods: {
    getList() {
      var _this = this;
      indexOp("/enterprise_user/index").then((res) => {
        if (res && res.status == 200) {
          _this.list = res.data;
        }
      });
    },
    onDelete(id) {
      var _this = this;
      var api = "/enterprise_user/destroy";
      var data = {
        id: id,
      };
      _this.$dialog
        .confirm({
          title: "提示",
          message: "确认进行删除操作？",
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        })
        .then((res) => {
          _this.$toast.loading({
            message: "",
            forbidClick: true,
          });
          indexOp(api, data).then((res) => {
            if (res && res.status == 200) {
              _this.$toast.success("修改成功！");
              setTimeout(() => {
                _this.reload();
              }, 500);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    toEdit(id) {
      this.$router.push({
        path: "/userManageEdit",
        query: {
          id: id,
        },
      });
    },
    toAdd() {
      this.$router.push("/userManageAdd");
    },
    toBack() {
      this.$router.go(-1);
    },
  },
  components: {},
};
</script>

<style scoped >
</style>
